/**
 * @flow
 * Created by neo on 01.06.17.
 */

import {observable, computed, action} from 'mobx';
import {FlightOfferAircraft} from "./FlightOffer";
import BackendFactory from "../Services/BackendFactory";
import mobx from "mobx";

export default class Voucher {
  @observable id: numeric;
  @observable code: string = '';
  @observable value: numeric = 0;
  @observable currency_code: string;
  @observable valid_until: Date;
  @observable offer_passenger_count: numeric;
  @observable aircraft_offer: FlightOfferAircraft;

  constructor(json?: any) {
    if(json) {
      this.id = json.id;
      this.code = json.code || '';
      this.value = parseFloat(json.value) || 0;
      this.currency_code = json.currency_code;
      this.valid_until = json.valid_until ? new Date(json.valid_until) : null;
      this.aircraft_offer = new FlightOfferAircraft(json.aircraft_offer);
      this.offer_passenger_count = json.offer_passenger_count;
    }
  }

  @action valueRemaining(price: numeric): numeric {
    return Math.max(0, this.value - price);
  }

  @action coversEntireBooking(booking): boolean {
    return !this.aircraft_offer.id ||
      this.aircraft_offer.id === booking.aircraft.id || booking.passengerCount === this.offer_passenger_count;
  }

  static async get(code) {
    const backend = await BackendFactory();
    const res = await backend.get('/voucher/' + code);

    if (res.ok) {
      return new Voucher(res.data.voucher);
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/Voucher.js